import styled from 'styled-components';
import { Button as ButtonComponent } from 'junto-ui';
import {
  tokens,
  DocumentDetail,
  LinkIcon,
  Download,
  ChainIcon as IconChain
} from '@plataforma/components';
import { colors, grid, fonts } from '_/styles';

export const BoxContainer = styled.div`
  display: flex;
  padding: 0 ${grid.large} 0 0;
  min-height: 168px;
  border: 1px dashed ${colors.divider};
  margin-top: ${grid.large};
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 48px;
`;

export const DocumentIcon = styled(DocumentDetail)``;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Title = styled.div`
  color: ${colors.textAlternative};
  font-weight: ${tokens.font.weight.semibold};
  font-size: ${fonts.size.medium};
  padding-left: 8px;
`;

export const Text = styled.div`
  color: ${colors.textAlternative};
  font-size: ${fonts.size.default};
  padding-left: 8px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LinkButtonIcon = styled(LinkIcon)`
  width: 17px !important;
  height: 17px !important;
`;

export const DownloadIcon = styled(Download)`
  width: 28px;
  height: 28px;
`;

export const ChainIcon = styled(IconChain)`
  margin: 0 ${grid.small};
  g {
    fill: #859099;
  }
`;

export const Button = styled(ButtonComponent)`
  width: 100%;
  margin-top: ${grid.large};
  font-family: ${tokens.font.family.metropolis};
  font-weight: ${tokens.font.weight.semibold};
`;
